/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
function e(e){return null!=e&&"object"==typeof e&&"2d"===e.type&&"linkchart"===e.view2dType}export{e as isLinkChartView};
